export default {
	data: function(){
		return {
		}
	},
    methods: {
        getMenusWihtLanguages(hotel_id) {
			this.$vs.loading();

            let token = localStorage.getItem('usertoken');
			
			this.$api({
				method: 'get',
				url: '/myvilagale/hotel/' + this.hotel_id + '/menu/languages',
				params: {
					token: token,
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
			.then((res) => {
				this.menus = res.data['menus'];
				this.$vs.loading.close();
			})
			.catch((err) => {
                this.$vs.loading.close();
			});
		},

		/* getChapters(language_menu) {
			this.$vs.loading();

            let token = localStorage.getItem('usertoken');
			
			this.$api({
				method: 'get',
				url: '/myvilagale/hotel/menu/languages/' + language_menu.id + '/chapter',
				params: {
					token: token,
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
			.then((res) => {
				for (let index = 0; index < res.data.length; index++) {
					this.$set(this.existing_chapters, index, res.data[index]);
				}
				this.$vs.loading.close();
				this.selected_menu = language_menu;
				this.show_menus = false;
			})
			.catch((err) => {
                this.$vs.loading.close();
			});
		}, */
		
		updateLocale(locale, refresh = true) {
			this.$i18n.locale = locale;
			window.localStorage.setItem('locale', locale);
			if(typeof this.$route.params.lang !== 'undefined') {
				let params = this.$route.params;
				params.lang = locale;
				if(refresh){
					this.$router.push({name: this.$route.name, params, query: this.$route.query});
				}
				
			}
        },
        
        getMenus(hotel_id, callback) {
        	if(typeof hotel_id != 'undefined' && hotel_id != ''){
        		this.$vs.loading();
	            let token = localStorage.getItem('usertoken');
	                
	            this.$api({
	                method: 'get',
	                url: '/myvilagale/hotel/' + hotel_id + '/menu',
	                params: {
	                    token: token,
	                },
	                headers: {
	                    Authorization: 'Bearer ' +process.env.VUE_APP_TOKEN
	                }
	            })
	            .then((res) => {
	                this.menus = res.data;
	                this.$vs.loading.close();
	                if(typeof callback !== 'undefined') {
	                	callback();
	                }
	            })
	            .catch((err) => {
	                this.$vs.loading.close();
	            });
        	}
            
        },

        changeStatus(id, visibility, item_type) {
            this.$vs.loading();
            let params = {
                id: id,
                visibility: visibility == true ? 0 : 1,
                item_type: item_type
            }
            
            let that = this;
            
            this.$api.put( '/myvilagale/hotel/' + this.changeHotel + '/menu/change-status?token=' + localStorage.getItem('usertoken'),
                params,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
                    }
                }).then(function(res) {
                    that.$vs.loading.close();
                    that.$vs.notify({
                        text: 'Estado alterado com sucesso.',
                        color:'success',
                        position:'bottom-right',
						iconPack: 'feather',
						icon:'icon-check'
                    });
                })
                .catch(function(err) {
					that.$vs.loading.close();
					that.$vs.notify({
                        text: 'Erro ao alterar estado.',
                        color:'danger',
                        position:'bottom-right',
						iconPack: 'feather',
						icon:'icon-alert-triangle'
                    });
                });
        },

        getChapters(language_menu, callback) {
			this.$vs.loading();

            let token = localStorage.getItem('usertoken');
			
			this.$api({
				method: 'get',
				url: '/myvilagale/hotel/menu/languages/' + language_menu.id + '/chapter',
				params: {
					token: token,
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
			.then((res) => {
				for (let index = 0; index < res.data.length; index++) {
					this.$set(this.chapters, index, res.data[index]);
				}
				this.$vs.loading.close();
				this.selected_menu = language_menu;
				if(typeof callback !== 'undefined') {
					callback();
				}
				//this.show_menus = false;
			})
			.catch((err) => {
				this.$vs.loading.close();
			});
        },
        
        getSellableItems(hotel_id, warehouse_id, callback) {
			this.$vs.loading();
            let token = localStorage.getItem('usertoken');
			
			this.$api({
				method: 'get',
				url: '/myvilagale/hotel/' + hotel_id + '/sellable_items/' + warehouse_id,
				params: {
					token: token,
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
			.then((res) => {
				this.sellable_items_list = res.data['sellableItems'];
				if(this.sellable_items_list.length == 0) {
					this.$vs.notify({
						time: 4000,
						text: 'Artigos de venda não disponíveis.',
						color:'danger',
						position:'bottom-right',
						iconPack: 'feather',
						icon:'icon-alert-triangle'
					});
				}
				this.$vs.loading.close();
				if(typeof callback !== 'undefined') {
					callback();
				}
			})
			.catch((err) => {
				this.$vs.loading.close();

			});
		},

		generateImgPath(file) {
            return URL.createObjectURL(file);
        },

        activeItems(arr) {
			if (!arr) {
				return [];
			}

			let newArr = [];

			arr.forEach(x => {
				if (x.visibility == 1) {
					newArr.push(x)
				}
			});

			return newArr;
        },
        
        convertToBool(arr) {
			if (!arr) {
				return [];
			}
           
            arr.forEach(x => {
				x.visibility = x.visibility == 1 ? true : false;
				
				if (x.room_service) {
					x.room_service = x.room_service == 1 ? true : false;
				}
            });

            return arr;
        },
        // color: green ou red senão fica primary
        notify(text, color, seconds){
            var icon = 'icon-alert-circle';
            var time = seconds == null ? 5*1000 : seconds*1000;
            
            if(color == 'green'){
                color = 'success';
                icon = 'icon-check';
	        	if(text == '' || text == null){
	        		text = 'Success';
	        	}
            }else if(color == 'red'){
                color = 'danger';
                icon = 'icon-alert-triangle';
	        	if(text == '' || text == null){
	        		text = 'Erro';
	        	}
            }else{
                color = 'primary';
            }
            this.$vs.notify({
                time: time,
                text: text,
                color: color,
                iconPack: 'feather',
                icon: icon
            })
        },
        isLoggedIn(){
        	return JSON.parse(localStorage.getItem('userSession')) !== null; 
        },
        getUserRole(){
        	this.$user = JSON.parse(localStorage.getItem('userSession'));
        	return this.$user != null ? this.$user.role : null;
        },
        isStaff(){
        	this.$user = JSON.parse(localStorage.getItem('userSession'));
        	return this.$user != null ? this.$user.is_staff : null;
        },
        forceLoginChange(){
        	this.$user = JSON.parse(localStorage.getItem('userSession'));
        	return this.$user != null ? this.$user.forceLoginChange : null;
        },
        checkRsvStatus(callback) {
        	this.$api({
				method: 'get',
				url: '/myvilagale/get_rsv_status',
				params: {
					token: this.$user.usertoken,
					num_reserva: this.$user.hotel.num_reserva
				},
			})
			.then(function (res) {
				callback(res.data);
			}) 
			.catch( function (err) {
                
			})
			.then(function() {
				
			});
		},
        logout(){
            this.$store.dispatch('eCommerce/clearCart');
            this.$user = null;
            localStorage.removeItem('usertoken');
            localStorage.removeItem('hotels');
			this.$router.push({name: 'pageLogin'});
        },
        buildFormData(formData, data, parentKey) {
            if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                let that = this;
                Object.keys(data).forEach(key => {
                    that.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                });
            } else {
                const value = data == null ? '' : data;
                formData.append(parentKey, value);
            }
        },
		isMobile() {
			let check = false;
			(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
			return check;
		},
    }
}